<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="payAmount">
        <span slot="label"><a-tooltip>{{ $t('支付金额') }}<template
          slot="title">{{ $t('支付金额') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.payAmount" :step="1" :max="999999" style="width: 100%" :placeholder="$t('请输入')+$t('支付金额')"/>
      </a-form-model-item>
      <a-form-model-item prop="obtainAmount">
        <span slot="label"><a-tooltip>{{ $t('获得数') }}<template slot="title">{{ $t('获得数') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.obtainAmount" :step="1" :max="999999" style="width: 100%" :placeholder="$t('请输入')+$t('获得数')"/>
      </a-form-model-item>
      <a-form-model-item prop="giftAmount">
        <span slot="label"><a-tooltip>{{ $t('赠送数') }}<template slot="title">{{ $t('赠送数') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.giftAmount" :step="1" :max="999999" style="width: 100%" :placeholder="$t('请输入')+$t('赠送数')"/>
      </a-form-model-item>
      <a-form-model-item prop="finalAmount">
        <span slot="label"><a-tooltip>{{ $t('合计获得') }}<template slot="title">{{ $t('合计获得') }}</template></a-tooltip> </span>
        <span>{{Number(form.obtainAmount) +Number(form.giftAmount)}}</span>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label"><a-tooltip>{{ $t('备注') }}<template
          slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getRechargeConfig, addRechargeConfig, updateRechargeConfig} from '@/api/user/rechargeConfig'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        type: 2,
        payAmount: null,
        obtainAmount: null,
        giftAmount: null,
        finalAmount: null,
        sort: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [{required: true, message: this.$t('类型 1:金币 2:余额') + this.$t('不能为空'), trigger: 'change'}],
        payAmount: [{required: true, message: this.$t('支付金额') + this.$t('不能为空'), trigger: 'blur'}],
        obtainAmount: [{required: true, message: this.$t('获得数') + this.$t('不能为空'), trigger: 'blur'}],
        giftAmount: [{required: true, message: this.$t('赠送数') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        type: 2,
        payAmount: null,
        obtainAmount: null,
        giftAmount: null,
        finalAmount: null,
        sort: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeConfig({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateRechargeConfig(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addRechargeConfig(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
